export const ALERTS_URL = '/v6/alerts'
export const ALERTS_QUERY_KEY = 'alerts'

export const ALERT_CATEGORY_LABELS: Record<string, string> = {
  cognitiveAndBehavioural: 'Cognitive & Behavioural',
  medicationAndNutrition: 'Medication & Nutrition',
  mobilityAndSafety: 'Mobility & Safety',
  physicalHealth: 'Physical Health'
}

export const ALERT_STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  enteredInError: 'Entered in Error',
  resolved: 'Resolved'
}

export const ALERT_STATUS_COLORS: Record<string, string> = {
  active: 'orange',
  enteredInError: 'default',
  resolved: 'default'
}
